export const SkeletorSymbol = Symbol()

export const DEFAULT_OPTIONS = {
  shimmer: true,
}
